import { createReducer } from "@reduxjs/toolkit";
const initialState = {
  isLoading: true,
};
export const productReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("getAllProductsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getAllProductsSuccess", (state, action) => {
      state.isLoading = false;
      state.allProducts = action.payload;
      console.log("Reducer: Products fetched successfully", action.payload);
    })
    .addCase("getAllProductsFailed", (state, action) => {
      state.isLoading = false;
    state.error = action.payload;
    })


    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});
